'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var reactToastify = require('react-toastify');
var React = require('react');
var T = require('@tunz/translation');
var reactBootstrap = require('react-bootstrap');
var io5 = require('react-icons/io5');
var useNotificationCenter = require('react-toastify/addons/use-notification-center');
var Button = require('react-bootstrap/Button');
var Offcanvas = require('react-bootstrap/Offcanvas');
var io = require('react-icons/io');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var T__default = /*#__PURE__*/_interopDefaultLegacy(T);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var Offcanvas__default = /*#__PURE__*/_interopDefaultLegacy(Offcanvas);

const CopyButton = (props) => {
    const { message } = props;
    const copyMessage = (msg) => {
        navigator.clipboard.writeText(msg);
    };
    return (React__default["default"].createElement(reactBootstrap.Button, { id: "copyButton", title: "Copy message", size: "sm", variant: "outline-light", onClick: () => copyMessage(message), "data-testid": "displayer_copy_button" },
        React__default["default"].createElement(io5.IoCopySharp, null)));
};

/**
 * Displays an error in an easy way
 */
const ErrorDisplayer = (error, action, actionLabel) => {
    const msg = error instanceof Error ? error.message : error;
    return reactToastify.toast.error(React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("b", null,
            React__default["default"].createElement(T__default["default"], { defaultValue: "An error occurred" }, "ERROR_OCCURRED")),
        React__default["default"].createElement("br", null),
        msg,
        React__default["default"].createElement("div", { className: "buttonArea" },
            action && (React__default["default"].createElement(reactBootstrap.Button, { size: "sm", variant: "outline-light", onClick: action }, actionLabel || 'View')),
            React__default["default"].createElement(CopyButton, { message: msg }))), { theme: 'colored' });
};

/**
 * Displays an error in an easy way
 */
const SuccessDisplayer = (message, action, actionLabel) => reactToastify.toast.success(React__default["default"].createElement(React__default["default"].Fragment, null,
    React__default["default"].createElement("b", null,
        React__default["default"].createElement(T__default["default"], { defaultValue: "Success" }, "SUCCESS_TITLE")),
    React__default["default"].createElement("br", null),
    message,
    React__default["default"].createElement("div", { className: "buttonArea" },
        action && (React__default["default"].createElement(reactBootstrap.Button, { size: "sm", variant: "outline-light", onClick: action }, actionLabel || 'View')),
        React__default["default"].createElement(CopyButton, { message: message }))), { theme: 'colored' });

const Notification = (props) => {
    const { notification, remove } = props;
    const tmpToDate = (tmp) => new Date(tmp);
    return (React__namespace.createElement("li", { key: notification.id, className: notification.type === 'error' ? 'errorNotification' : 'successNotification' },
        React__namespace.createElement(Button__default["default"], { "data-testid": "remove_notification_button", variant: "outline-light", size: "sm", className: "float-end", onClick: () => remove(notification.id) },
            React__namespace.createElement(io.IoMdClose, null)),
        React__namespace.createElement("div", null, tmpToDate(notification.createdAt).toLocaleString()),
        React__namespace.createElement("div", null,
            React__namespace.createElement(React__namespace.Fragment, null,
                notification.type,
                " : ",
                notification.content))));
};

const NotificationCenter = () => {
    const { notifications, clear, remove } = useNotificationCenter.useNotificationCenter();
    const [show, setShow] = React.useState(false);
    const handleShow = () => setShow(!show);
    const options = {
        scroll: true,
        backdrop: true,
        placement: 'end',
    };
    return (React__namespace.createElement(React__namespace.Fragment, null,
        React__namespace.createElement(Button__default["default"], { id: "notificationButton", "data-testid": "notification_button", variant: "outline-dark", className: "float-end rounded-circle notificationButton", onClick: handleShow },
            React__namespace.createElement(io5.IoNotifications, null),
            notifications.length > 0 && (React__namespace.createElement("sup", null,
                React__namespace.createElement(reactBootstrap.Badge, { pill: true, bg: "light", text: "dark" }, notifications.length)))),
        React__namespace.createElement(Offcanvas__default["default"], Object.assign({ show: show, onHide: handleShow }, options),
            React__namespace.createElement(Offcanvas__default["default"].Header, { closeButton: true },
                React__namespace.createElement(Offcanvas__default["default"].Title, null, "Notifications")),
            React__namespace.createElement(Offcanvas__default["default"].Body, { id: "notificationInfo", "data-testid": "notification_info" },
                notifications.length > 0 ? (React__namespace.createElement(Button__default["default"], { "data-testid": "clear_notifications_button", variant: "outline-primary", onClick: clear }, "Clear Notifications")) : (React__namespace.createElement("div", null, "You have no notifications.")),
                React__namespace.createElement("ul", { className: "notification", "data-testid": "notification_list" }, notifications.map(notification => (React__namespace.createElement(Notification, { notification: notification, remove: remove, key: notification.id }))))))));
};

Object.defineProperty(exports, 'ToastContainer', {
	enumerable: true,
	get: function () { return reactToastify.ToastContainer; }
});
exports.NotificationCenter = NotificationCenter;
exports.copyMessage = CopyButton;
exports.displayError = ErrorDisplayer;
exports.displaySuccess = SuccessDisplayer;
